module.exports = __webpack_public_path__ + "static/img/menu2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu2.png
// module id = 556
// module chunks = 0